import { toLocalDateTime } from '../../../../utils/helpers/formatting';
import { formatValue } from '../../../../utils/helpers/stats.dataManipulation';
import { SCOUT_TEMPLATE_MODES } from '../../Scout.constants';
import { getScoutTemplateMetricCount } from './LoadModal.helpers';

export const formatScoutLoadTemplateTable = (data, headers) => {
  if (data?.length === 0 || headers?.length === 0) return [];

  const templateRows = data?.map((template) =>
    headers.reduce(
      (row, h) => {
        let label;
        let value;
        switch (h.key) {
          case 'name':
            label = template.name || template.id;
            value = label;
            break;
          case 'lastModified':
            label = toLocalDateTime(template.lastModified);
            value = template.lastModified;
            break;
          case 'metricCount': {
            const count = getScoutTemplateMetricCount(template);
            label = count;
            value = count;
            break;
          }
          case 'lastEditor':
            label = template.creator;
            value = template.creator;
            break;
          case 'actions':
            label = null;
            break;

          default:
            label = formatValue(template[h.key], h.units);
            break;
        }
        const hasNcaaTransferPortal = template.selectedBiometrics?.find(
          (b) => b.key === 'ncaaTransferPortal',
        )?.value;
        return {
          ...row,
          [h.key]: { ...h, label, value, hasNcaaTransferPortal },
        };
      },
      { id: template.id || '-', creatorId: template.creatorId || '-' }, // will not show as a column
    ),
  );

  return templateRows;
};

export const getScoutLoadModalTitle = (templateMode, templateName) => {
  switch (templateMode) {
    case SCOUT_TEMPLATE_MODES.DELETE:
      return `Delete "${templateName || ''}" filter set`;
    case SCOUT_TEMPLATE_MODES.EDIT:
      return 'Rename filter set';
    case SCOUT_TEMPLATE_MODES.SAVE_AS:
      return 'Save as new filter set';
    default:
      return '';
  }
};
